import Peer from "peerjs";
export default class SenderConnection {
    constructor(onAdminOpen, onAdminMessage, onAdminClose, callback) {
        this.onAdminOpen = onAdminOpen
        this.onAdminMessage = onAdminMessage
        this.onAdminClose = onAdminClose
        this.conn = null
        this.lastPeerId = null
        // this.peer = new Peer({
        //     secure:true,
        //     host: 'akashic-paths-peer-server.herokuapp.com',
        //     port: 443
        // })    

        this.peer = new Peer({ debug:2, config: {'iceServers': [
            { url: "stun:stun.l.google.com:19302" },
            { url: "stun:stun1.l.google.com:19302" },
            //{ urls: "stun:stun.relay.metered.ca:80"},
              {
                urls: "turn:a.relay.metered.ca:80",
                username: "48995fe759ac8acd37a7da1a",
                credential: "mMQC9m3b/AuYgSdS",
              },
              {
                urls: "turn:a.relay.metered.ca:80?transport=tcp",
                username: "48995fe759ac8acd37a7da1a",
                credential: "mMQC9m3b/AuYgSdS",
              },
              {
                urls: "turn:a.relay.metered.ca:443",
                username: "48995fe759ac8acd37a7da1a",
                credential: "mMQC9m3b/AuYgSdS",
              },
              {
                urls: "turn:a.relay.metered.ca:443?transport=tcp",
                username: "48995fe759ac8acd37a7da1a",
                credential: "mMQC9m3b/AuYgSdS",
              },
            ]}})        

        this.peer.on('open', () => {
            // Workaround for peer.reconnect deleting previous id
            if (this.peer.id === null) {
                console.log('Received null id from peer open');
                this.peer.id = this.lastPeerId;
            } else {
                this.lastPeerId = this.peer.id;
            }
            console.log('ID: ' + this.peer.id);
            callback()
        });

        this.peer.on('connection', function (c) {
            c.on('open', function () {
                c.send("Sender does not accept incoming connections");
                setTimeout(function () { c.close(); }, 500);
            });
        });

        this.peer.on('disconnected', function () {
            status.innerHTML = "Connection lost. Please reconnect";
            console.log('Connection lost. Please reconnect');

            // Workaround for this.peer.reconnect deleting previous id
            this.peer.id = this.lastPeerId;
            this.peer._lastServerId = this.lastPeerId;
            this.peer.reconnect();
        });

        this.peer.on('close', function () {
            this.conn = null;
            console.log('Connection destroyed');
        });

        this.peer.on('error', function (err) {
            console.log(err);
            //alert('' + err);
        }); 
    }

    async connect(connectionId){
        if (this.conn) {
            this.conn.close();
        }
        console.log(this.peer)
        this.conn = this.peer.connect(connectionId, {
                reliable: true
            })
        // this.conn = this.peer.connect(connectionId, {
        //     reliable: true
        // });

        this.conn.on('open', () => {
            console.log("Connected to: " + this.conn.peer);
            this.onAdminOpen()
            // Check URL params for comamnds that should be sent immediately
            // var command = this.getUrlParam("command");
            // if (command)
            //     this.conn.send(command);
        });
        // Handle incoming data (messages only since this is the signal sender)
        this.conn.on('data', (data) => {
            console.log(this)
            this.onAdminMessage(data)            
        });

        this.conn.on('close', () => {
            this.onAdminClose()
            console.log("connection closed")
        });
    }

    send(message){
        console.log("send message", message)
        this.conn.send(message)
    }

    close(){
        this.conn.close();
    }

    getUrlParam(name) {
        name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.href);
        if (results == null)
            return null;
        else
            return results[1];
    }
}